import React from "react";
import './textAreaField.scss';

interface Props {
    id?: string;
    name?: string;
    classname?: string;
    placeholder?: string;
    defaultValue?: string | number;
    maxCharacter?: number | undefined;
    characterCount?: number | null | undefined;
    error?: any;
    onblur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void | undefined;
    inputValue?: string | number | readonly string[] | undefined;
    onchange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    message?: any;
    autoComplete?: any;
    label?: string
}

export const TextAreaField: React.FC<Props> = ({
                                                   id,
                                                   classname,
                                                   onchange,
                                                   placeholder,
                                                   name,
                                                   error,
                                                   onblur,
                                                   inputValue,
                                                   defaultValue,
                                                   message,
                                                   maxCharacter,
                                                   autoComplete,
                                                   label
                                               }) => {
    const characters = React.useRef(null) as any;
    return (
        <div className={'text-area-field'}>
            {label && <span className={'text-area-field_label'}>{label}:</span>}
            <div className="text-area-field_container" data-cy={id}>
                <textarea
                    ref={characters}
                    className={[classname, "text-area-field_container_input", error ? "text-area-field_container_input_error" : null].join(" ")}
                    onChange={onchange}
                    name={name}
                    placeholder={placeholder}
                    onBlur={onblur}
                    value={inputValue}
                    defaultValue={defaultValue}
                    maxLength={maxCharacter}
                    id={id || ""}
                    autoComplete={autoComplete ? autoComplete : "on"}
                />
            </div>
            <div className="text-area-field_info_wrapper">
                <span id="--name__error" className="text-area-field_info_wrapper_message">
                  {message}
                </span>
            </div>
        </div>
    );
};

export default TextAreaField;
